<template>
  <div class="copyright">
    <!-- 底部版权备案--头 -->
    <div class="copyright">
      <p>醴陵市金融调解</p>
      <p>Copyright © 2023</p><br>
      <a :href="icp_link">
        ICP备案号：
        <p>{{ icp_number }}</p>
      </a>
      <a :href="gongan_link">
        公安备案号：
        <p>{{ gongan_beian }}</p>
      </a>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "copyright",
  data() {
    return {
      gongan_beian: '',
      gongan_link: '',
      icp_link: '',
      icp_number: ''
    }
  },

  mounted() {
    console.log();
    axios.post('/api/index/website_info', {}).then(res => {
      this.gongan_beian = res.data.data.gongan_beian;
      this.gongan_link = res.data.data.gongan_link;
      this.icp_link = res.data.data.icp_link;
      this.icp_number = res.data.data.icp_number;
    }).catch(e => {
      console.error(e);
    });

  }
};
</script>

<style scoped>
a {
  color: #404040;
}

.copyright {
  margin: 0.3125rem 0;
  font-size: 0.75rem;
  color: #404040;
  text-align: center;
}

.copyright p {
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/copyright.vue